import { getBoxURL, getImageUrl, sortLinkNum, sortNum } from './index';

export const getTemplateComponents = (pageData) => {
  const boxGroup = pageData?.template?.box_groups?.filter(
    ({ group }) => group,
  )[0]?.group;
  const imageLink = boxGroup?.image_link?.map(
    ({ image_link }) => image_link,
  )[0];
  const linkList = boxGroup?.links_lists?.map(
    ({ links_list }) => links_list,
  )[0];
  const links = sortLinkNum(linkList?.links);
  const cta = boxGroup?.call_to_actions?.map(({ cta }) => cta)[0] || {};
  const banner = boxGroup?.banners?.map(({ banner }) => banner)[0] || {};
  const navBoxes = sortLinkNum(boxGroup?.nav_box);
  const iconLinks = sortNum(boxGroup?.icon_links);
  const pageSectionGroups = boxGroup?.page_section_groups;
  const pageSections = boxGroup?.page_sections;

  return {
    banner: {
      image: banner?.image?.filename_disk ?? '',
      title: banner?.title ?? '',
      btnText: banner?.button_text ?? 'Learn More',
      category: banner?.banner_section_title ?? '',
      subtitle: banner?.description ?? '',
      url: getBoxURL(banner?.button_url ?? '#'),
    },
    cta: {
      btnText: cta?.button_text,
      title: cta?.title,
      url: getBoxURL(cta?.url),
    },
    imageLink: {
      imgURL: getImageUrl(imageLink?.image?.filename_disk),
      title: imageLink?.title,
      url: getBoxURL(imageLink?.url),
    },
    linkList: {
      links: links,
      title: linkList?.title,
    },
    navBoxes: navBoxes,
    iconLinks,
    pageSectionGroups,
    pageSections,
  };
};
